var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-time-select',{attrs:{"placeholder":_vm.placeholder,"picker-options":{
    start: '00:00',
    step: '00:30',
    end: '24:00',
  }},on:{"change":_vm.change},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }